import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { storeSessionConfigFromAppVariables, storeTokenIssuedAt } from '../helpers/session_helper'

const useSessionConfig = () => {
    const { appInfo } = useSelector(state => ({
        appInfo: state.appInfo.appInfo
    }))

    useEffect(() => {
        // Initialize session config when appInfo is loaded
        if (appInfo && appInfo.appVariables && Array.isArray(appInfo.appVariables)) {
            const sessionConfig = storeSessionConfigFromAppVariables(appInfo.appVariables)

            if (sessionConfig) {
                // Initialize token issued time if not already set
                const existingTokenIssuedAt = localStorage.getItem('tokenIssuedAt')
                if (!existingTokenIssuedAt && localStorage.getItem('_atk')) {
                    storeTokenIssuedAt()
                }
            }
        }
    }, [appInfo])
}

export default useSessionConfig